module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "icons"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "icon",
      "value": "${value}"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-adjust"
  }), _vm._v(" adjust")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-anchor"
  }), _vm._v(" anchor")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" archive")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" area-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows"
  }), _vm._v(" arrows")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h"
  }), _vm._v(" arrows-h")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v"
  }), _vm._v(" arrows-v")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  }), _vm._v(" asterisk")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-at"
  }), _vm._v(" at")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-automobile"
  }), _vm._v(" automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-balance-scale"
  }), _vm._v(" balance-scale")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" ban")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" bank "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" bar-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o"
  }), _vm._v(" bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" barcode")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v(" bars")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-0"
  }), _vm._v(" battery-0 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-1"
  }), _vm._v(" battery-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-2"
  }), _vm._v(" battery-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-3"
  }), _vm._v(" battery-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-4"
  }), _vm._v(" battery-4 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-empty"
  }), _vm._v(" battery-empty")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-full"
  }), _vm._v(" battery-full")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-half"
  }), _vm._v(" battery-half")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-quarter"
  }), _vm._v(" battery-quarter")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-battery-three-quarters"
  }), _vm._v(" battery-three-quarters")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bed"
  }), _vm._v(" bed")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-beer"
  }), _vm._v(" beer")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" bell")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" bell-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash"
  }), _vm._v(" bell-slash")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bell-slash-o"
  }), _vm._v(" bell-slash-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bicycle"
  }), _vm._v(" bicycle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-binoculars"
  }), _vm._v(" binoculars")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake"
  }), _vm._v(" birthday-cake")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bolt"
  }), _vm._v(" bolt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bomb"
  }), _vm._v(" bomb")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" book")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bookmark"
  }), _vm._v(" bookmark")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bookmark-o"
  }), _vm._v(" bookmark-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" briefcase")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bug"
  }), _vm._v(" bug")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" building")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v(" building-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" bullhorn")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bullseye"
  }), _vm._v(" bullseye")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" bus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cab"
  }), _vm._v(" cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  }), _vm._v(" calculator")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" calendar")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" calendar-check-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar-minus-o"
  }), _vm._v(" calendar-minus-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar-o"
  }), _vm._v(" calendar-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o"
  }), _vm._v(" calendar-plus-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o"
  }), _vm._v(" calendar-times-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" camera")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-camera-retro"
  }), _vm._v(" camera-retro")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" car")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down"
  }), _vm._v(" caret-square-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left"
  }), _vm._v(" caret-square-o-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right"
  }), _vm._v(" caret-square-o-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up"
  }), _vm._v(" caret-square-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cart-arrow-down"
  }), _vm._v(" cart-arrow-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cart-plus"
  }), _vm._v(" cart-plus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc"
  }), _vm._v(" cc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-certificate"
  }), _vm._v(" certificate")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" check")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" check-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" check-circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-square"
  }), _vm._v(" check-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" check-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _vm._v(" child")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  }), _vm._v(" circle-o-notch")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-thin"
  }), _vm._v(" circle-thin")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" clock-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" clone")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" close "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cloud"
  }), _vm._v(" cloud")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download"
  }), _vm._v(" cloud-download")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload"
  }), _vm._v(" cloud-upload")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-code"
  }), _vm._v(" code")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-code-fork"
  }), _vm._v(" code-fork")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-coffee"
  }), _vm._v(" coffee")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" cog")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" cogs")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" comment")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" comment-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" commenting")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-commenting-o"
  }), _vm._v(" commenting-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-comments"
  }), _vm._v(" comments")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _vm._v(" comments-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-compass"
  }), _vm._v(" compass")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-copyright"
  }), _vm._v(" copyright")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-creative-commons"
  }), _vm._v(" creative-commons")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" credit-card")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-crop"
  }), _vm._v(" crop")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" crosshairs")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" cube")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" cubes")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  }), _vm._v(" cutlery")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" dashboard "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" database")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" desktop")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-diamond"
  }), _vm._v(" diamond")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" dot-circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" download")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" edit "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  }), _vm._v(" ellipsis-h")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  }), _vm._v(" ellipsis-v")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" envelope")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" envelope-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-envelope-square"
  }), _vm._v(" envelope-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v(" eraser")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" exchange")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-exclamation"
  }), _vm._v(" exclamation")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" exclamation-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" exclamation-triangle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" external-link")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-external-link-square"
  }), _vm._v(" external-link-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" eye")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  }), _vm._v(" eye-slash")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eyedropper"
  }), _vm._v(" eyedropper")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fax"
  }), _vm._v(" fax")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-feed"
  }), _vm._v(" feed "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-female"
  }), _vm._v(" female")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet"
  }), _vm._v(" fighter-jet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o"
  }), _vm._v(" file-archive-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o"
  }), _vm._v(" file-audio-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" file-code-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" file-excel-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" file-image-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o"
  }), _vm._v(" file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" file-pdf-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o"
  }), _vm._v(" file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o"
  }), _vm._v(" file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" file-powerpoint-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o"
  }), _vm._v(" file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o"
  }), _vm._v(" file-video-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o"
  }), _vm._v(" file-word-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o"
  }), _vm._v(" file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-film"
  }), _vm._v(" film")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" filter")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fire"
  }), _vm._v(" fire")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fire-extinguisher"
  }), _vm._v(" fire-extinguisher")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" flag")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flag-checkered"
  }), _vm._v(" flag-checkered")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" flag-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flash"
  }), _vm._v(" flash "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" flask")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" folder")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-folder-o"
  }), _vm._v(" folder-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  }), _vm._v(" folder-open")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o"
  }), _vm._v(" folder-open-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-frown-o"
  }), _vm._v(" frown-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-futbol-o"
  }), _vm._v(" futbol-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gamepad"
  }), _vm._v(" gamepad")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gavel"
  }), _vm._v(" gavel")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gears"
  }), _vm._v(" gears "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gift"
  }), _vm._v(" gift")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" glass")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" globe")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-graduation-cap"
  }), _vm._v(" graduation-cap")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _vm._v(" group "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o"
  }), _vm._v(" hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o"
  }), _vm._v(" hand-lizard-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o"
  }), _vm._v(" hand-paper-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o"
  }), _vm._v(" hand-peace-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v(" hand-pointer-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o"
  }), _vm._v(" hand-rock-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o"
  }), _vm._v(" hand-scissors-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o"
  }), _vm._v(" hand-spock-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o"
  }), _vm._v(" hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hdd-o"
  }), _vm._v(" hdd-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-headphones"
  }), _vm._v(" headphones")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" heart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  }), _vm._v(" heart-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v(" heartbeat")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" history")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" home")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hotel"
  }), _vm._v(" hotel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass"
  }), _vm._v(" hourglass")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-1"
  }), _vm._v(" hourglass-1 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-2"
  }), _vm._v(" hourglass-2 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-3"
  }), _vm._v(" hourglass-3 "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-end"
  }), _vm._v(" hourglass-end")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-half"
  }), _vm._v(" hourglass-half")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-o"
  }), _vm._v(" hourglass-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hourglass-start"
  }), _vm._v(" hourglass-start")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-i-cursor"
  }), _vm._v(" i-cursor")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-image"
  }), _vm._v(" image "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  }), _vm._v(" inbox")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  }), _vm._v(" industry")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" info")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" info-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-institution"
  }), _vm._v(" institution "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" key")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-keyboard-o"
  }), _vm._v(" keyboard-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-language"
  }), _vm._v(" language")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-laptop"
  }), _vm._v(" laptop")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-leaf"
  }), _vm._v(" leaf")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-legal"
  }), _vm._v(" legal "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-lemon-o"
  }), _vm._v(" lemon-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-level-down"
  }), _vm._v(" level-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-level-up"
  }), _vm._v(" level-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-life-bouy"
  }), _vm._v(" life-bouy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-life-buoy"
  }), _vm._v(" life-buoy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-life-ring"
  }), _vm._v(" life-ring")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-life-saver"
  }), _vm._v(" life-saver "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" lightbulb-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" line-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-location-arrow"
  }), _vm._v(" location-arrow")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" lock")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _vm._v(" magic")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-magnet"
  }), _vm._v(" magnet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mail-forward"
  }), _vm._v(" mail-forward "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" mail-reply "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mail-reply-all"
  }), _vm._v(" mail-reply-all "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-male"
  }), _vm._v(" male")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v(" map")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" map-marker")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-map-o"
  }), _vm._v(" map-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-map-pin"
  }), _vm._v(" map-pin")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-map-signs"
  }), _vm._v(" map-signs")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  }), _vm._v(" meh-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-microphone"
  }), _vm._v(" microphone")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-microphone-slash"
  }), _vm._v(" microphone-slash")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus"
  }), _vm._v(" minus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  }), _vm._v(" minus-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus-square"
  }), _vm._v(" minus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o"
  }), _vm._v(" minus-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v(" mobile")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mobile-phone"
  }), _vm._v(" mobile-phone "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" money")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-moon-o"
  }), _vm._v(" moon-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mortar-board"
  }), _vm._v(" mortar-board "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" motorcycle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mouse-pointer"
  }), _vm._v(" mouse-pointer")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-music"
  }), _vm._v(" music")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  }), _vm._v(" navicon "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _vm._v(" newspaper-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  }), _vm._v(" object-group")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-object-ungroup"
  }), _vm._v(" object-ungroup")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paint-brush"
  }), _vm._v(" paint-brush")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _vm._v(" paper-plane")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  }), _vm._v(" paper-plane-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paw"
  }), _vm._v(" paw")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" pencil")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square"
  }), _vm._v(" pencil-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" pencil-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" phone")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-phone-square"
  }), _vm._v(" phone-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-photo"
  }), _vm._v(" photo "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" picture-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" pie-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _vm._v(" plane")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" plug")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" plus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" plus-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o"
  }), _vm._v(" plus-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" power-off")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" print")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece"
  }), _vm._v(" puzzle-piece")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" qrcode")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" question")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" question-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-quote-left"
  }), _vm._v(" quote-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-quote-right"
  }), _vm._v(" quote-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-random"
  }), _vm._v(" random")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-recycle"
  }), _vm._v(" recycle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" refresh")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-registered"
  }), _vm._v(" registered")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" remove "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  }), _vm._v(" reorder "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" reply")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-reply-all"
  }), _vm._v(" reply-all")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-retweet"
  }), _vm._v(" retweet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-road"
  }), _vm._v(" road")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rocket"
  }), _vm._v(" rocket")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rss"
  }), _vm._v(" rss")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rss-square"
  }), _vm._v(" rss-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" search")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-search-minus"
  }), _vm._v(" search-minus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-search-plus"
  }), _vm._v(" search-plus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" send "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-send-o"
  }), _vm._v(" send-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-server"
  }), _vm._v(" server")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" share")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" share-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square"
  }), _vm._v(" share-alt-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-square"
  }), _vm._v(" share-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-square-o"
  }), _vm._v(" share-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-shield"
  }), _vm._v(" shield")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ship"
  }), _vm._v(" ship")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" shopping-cart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v(" sign-in")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" sign-out")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" signal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" sitemap")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sliders"
  }), _vm._v(" sliders")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-smile-o"
  }), _vm._v(" smile-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-soccer-ball-o"
  }), _vm._v(" soccer-ball-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort"
  }), _vm._v(" sort")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  }), _vm._v(" sort-alpha-asc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }), _vm._v(" sort-alpha-desc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-asc"
  }), _vm._v(" sort-amount-asc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-amount-desc"
  }), _vm._v(" sort-amount-desc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-asc"
  }), _vm._v(" sort-asc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-desc"
  }), _vm._v(" sort-desc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-down"
  }), _vm._v(" sort-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc"
  }), _vm._v(" sort-numeric-asc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc"
  }), _vm._v(" sort-numeric-desc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sort-up"
  }), _vm._v(" sort-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle"
  }), _vm._v(" space-shuttle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-spinner"
  }), _vm._v(" spinner")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-spoon"
  }), _vm._v(" spoon")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-square"
  }), _vm._v(" square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-square-o"
  }), _vm._v(" square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" star")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star-half"
  }), _vm._v(" star-half")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star-half-empty"
  }), _vm._v(" star-half-empty "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star-half-full"
  }), _vm._v(" star-half-full "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star-half-o"
  }), _vm._v(" star-half-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  }), _vm._v(" star-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note"
  }), _vm._v(" sticky-note")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o"
  }), _vm._v(" sticky-note-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-street-view"
  }), _vm._v(" street-view")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-suitcase"
  }), _vm._v(" suitcase")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sun-o"
  }), _vm._v(" sun-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" support "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tablet"
  }), _vm._v(" tablet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _vm._v(" tachometer")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" tag")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" tags")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" tasks")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-taxi"
  }), _vm._v(" taxi")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-television"
  }), _vm._v(" television")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-terminal"
  }), _vm._v(" terminal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack"
  }), _vm._v(" thumb-tack")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down"
  }), _vm._v(" thumbs-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" thumbs-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" thumbs-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" thumbs-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" ticket")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" times")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" times-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-times-circle-o"
  }), _vm._v(" times-circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tint"
  }), _vm._v(" tint")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down"
  }), _vm._v(" toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left"
  }), _vm._v(" toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-off"
  }), _vm._v(" toggle-off")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-on"
  }), _vm._v(" toggle-on")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right"
  }), _vm._v(" toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up"
  }), _vm._v(" toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-trademark"
  }), _vm._v(" trademark")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" trash")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v(" trash-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v(" tree")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _vm._v(" trophy")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" truck")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tty"
  }), _vm._v(" tty")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  }), _vm._v(" tv "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-umbrella"
  }), _vm._v(" umbrella")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" university")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-unlock"
  }), _vm._v(" unlock")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  }), _vm._v(" unlock-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-unsorted"
  }), _vm._v(" unsorted "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" upload")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" user")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" user-plus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-user-secret"
  }), _vm._v(" user-secret")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-user-times"
  }), _vm._v(" user-times")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" users")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _vm._v(" video-camera")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-volume-down"
  }), _vm._v(" volume-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-volume-off"
  }), _vm._v(" volume-off")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-volume-up"
  }), _vm._v(" volume-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" warning "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair"
  }), _vm._v(" wheelchair")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" wifi")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" wrench")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-grab-o"
  }), _vm._v(" hand-grab-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-lizard-o"
  }), _vm._v(" hand-lizard-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down"
  }), _vm._v(" hand-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left"
  }), _vm._v(" hand-o-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right"
  }), _vm._v(" hand-o-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up"
  }), _vm._v(" hand-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-paper-o"
  }), _vm._v(" hand-paper-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-peace-o"
  }), _vm._v(" hand-peace-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer-o"
  }), _vm._v(" hand-pointer-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-rock-o"
  }), _vm._v(" hand-rock-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-scissors-o"
  }), _vm._v(" hand-scissors-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-spock-o"
  }), _vm._v(" hand-spock-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-stop-o"
  }), _vm._v(" hand-stop-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down"
  }), _vm._v(" thumbs-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-down"
  }), _vm._v(" thumbs-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-o-up"
  }), _vm._v(" thumbs-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  }), _vm._v(" thumbs-up")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ambulance"
  }), _vm._v(" ambulance")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-automobile"
  }), _vm._v(" automobile "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bicycle"
  }), _vm._v(" bicycle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bus"
  }), _vm._v(" bus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cab"
  }), _vm._v(" cab "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" car")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fighter-jet"
  }), _vm._v(" fighter-jet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" motorcycle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _vm._v(" plane")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rocket"
  }), _vm._v(" rocket")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ship"
  }), _vm._v(" ship")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-space-shuttle"
  }), _vm._v(" space-shuttle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-subway"
  }), _vm._v(" subway")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-taxi"
  }), _vm._v(" taxi")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-train"
  }), _vm._v(" train")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" truck")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair"
  }), _vm._v(" wheelchair")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-genderless"
  }), _vm._v(" genderless")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-intersex"
  }), _vm._v(" intersex "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mars"
  }), _vm._v(" mars")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mars-double"
  }), _vm._v(" mars-double")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke"
  }), _vm._v(" mars-stroke")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-h"
  }), _vm._v(" mars-stroke-h")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mars-stroke-v"
  }), _vm._v(" mars-stroke-v")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-mercury"
  }), _vm._v(" mercury")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-neuter"
  }), _vm._v(" neuter")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-transgender"
  }), _vm._v(" transgender")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-transgender-alt"
  }), _vm._v(" transgender-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-venus"
  }), _vm._v(" venus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-venus-double"
  }), _vm._v(" venus-double")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-venus-mars"
  }), _vm._v(" venus-mars")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" file")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o"
  }), _vm._v(" file-archive-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-audio-o"
  }), _vm._v(" file-audio-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" file-code-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" file-excel-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _vm._v(" file-image-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-movie-o"
  }), _vm._v(" file-movie-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" file-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" file-pdf-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-photo-o"
  }), _vm._v(" file-photo-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-picture-o"
  }), _vm._v(" file-picture-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-powerpoint-o"
  }), _vm._v(" file-powerpoint-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-sound-o"
  }), _vm._v(" file-sound-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" file-text")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" file-text-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-video-o"
  }), _vm._v(" file-video-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-word-o"
  }), _vm._v(" file-word-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-zip-o"
  }), _vm._v(" file-zip-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch"
  }), _vm._v(" circle-o-notch")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" cog")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" gear "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" refresh")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-spinner"
  }), _vm._v(" spinner")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-square"
  }), _vm._v(" check-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" check-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" dot-circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus-square"
  }), _vm._v(" minus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-minus-square-o"
  }), _vm._v(" minus-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o"
  }), _vm._v(" plus-square-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-square"
  }), _vm._v(" square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-square-o"
  }), _vm._v(" square-o")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex"
  }), _vm._v(" cc-amex")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club"
  }), _vm._v(" cc-diners-club")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover"
  }), _vm._v(" cc-discover")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb"
  }), _vm._v(" cc-jcb")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard"
  }), _vm._v(" cc-mastercard")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal"
  }), _vm._v(" cc-paypal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe"
  }), _vm._v(" cc-stripe")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa"
  }), _vm._v(" cc-visa")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" credit-card")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet"
  }), _vm._v(" google-wallet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paypal"
  }), _vm._v(" paypal")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-area-chart"
  }), _vm._v(" area-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" bar-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o"
  }), _vm._v(" bar-chart-o "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" line-chart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" pie-chart")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin"
  }), _vm._v(" bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-btc"
  }), _vm._v(" btc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cny"
  }), _vm._v(" cny "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" dollar "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eur"
  }), _vm._v(" eur")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-euro"
  }), _vm._v(" euro "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gbp"
  }), _vm._v(" gbp")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gg"
  }), _vm._v(" gg")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle"
  }), _vm._v(" gg-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ils"
  }), _vm._v(" ils")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-inr"
  }), _vm._v(" inr")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-jpy"
  }), _vm._v(" jpy")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-krw"
  }), _vm._v(" krw")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" money")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rmb"
  }), _vm._v(" rmb "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rouble"
  }), _vm._v(" rouble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rub"
  }), _vm._v(" rub")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ruble"
  }), _vm._v(" ruble "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" rupee "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-shekel"
  }), _vm._v(" shekel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sheqel"
  }), _vm._v(" sheqel "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-try"
  }), _vm._v(" try")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-turkish-lira"
  }), _vm._v(" turkish-lira "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-usd"
  }), _vm._v(" usd")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-won"
  }), _vm._v(" won "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-yen"
  }), _vm._v(" yen "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-align-center"
  }), _vm._v(" align-center")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" align-justify")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-align-left"
  }), _vm._v(" align-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-align-right"
  }), _vm._v(" align-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bold"
  }), _vm._v(" bold")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chain"
  }), _vm._v(" chain "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chain-broken"
  }), _vm._v(" chain-broken")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v(" clipboard")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-columns"
  }), _vm._v(" columns")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  }), _vm._v(" copy "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cut"
  }), _vm._v(" cut "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dedent"
  }), _vm._v(" dedent "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v(" eraser")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" file")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" file-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" file-text")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" file-text-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  }), _vm._v(" files-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" floppy-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-font"
  }), _vm._v(" font")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-header"
  }), _vm._v(" header")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-indent"
  }), _vm._v(" indent")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-italic"
  }), _vm._v(" italic")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" link")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" list")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" list-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" list-ol")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" list-ul")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-outdent"
  }), _vm._v(" outdent")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" paperclip")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paragraph"
  }), _vm._v(" paragraph")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paste"
  }), _vm._v(" paste "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" repeat")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rotate-left"
  }), _vm._v(" rotate-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rotate-right"
  }), _vm._v(" rotate-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" save "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-scissors"
  }), _vm._v(" scissors")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-strikethrough"
  }), _vm._v(" strikethrough")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-subscript"
  }), _vm._v(" subscript")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-superscript"
  }), _vm._v(" superscript")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" table")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-text-height"
  }), _vm._v(" text-height")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-text-width"
  }), _vm._v(" text-width")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" th")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" th-large")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  }), _vm._v(" th-list")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-underline"
  }), _vm._v(" underline")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" undo")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-unlink"
  }), _vm._v(" unlink "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  }), _vm._v(" angle-double-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" angle-double-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-right"
  }), _vm._v(" angle-double-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  }), _vm._v(" angle-double-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  }), _vm._v(" angle-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" angle-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" angle-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  }), _vm._v(" angle-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-down"
  }), _vm._v(" arrow-circle-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  }), _vm._v(" arrow-circle-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-down"
  }), _vm._v(" arrow-circle-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left"
  }), _vm._v(" arrow-circle-o-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  }), _vm._v(" arrow-circle-o-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-up"
  }), _vm._v(" arrow-circle-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  }), _vm._v(" arrow-circle-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up"
  }), _vm._v(" arrow-circle-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  }), _vm._v(" arrow-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" arrow-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" arrow-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  }), _vm._v(" arrow-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows"
  }), _vm._v(" arrows")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt"
  }), _vm._v(" arrows-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-h"
  }), _vm._v(" arrows-h")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-v"
  }), _vm._v(" arrows-v")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  }), _vm._v(" caret-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-left"
  }), _vm._v(" caret-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-right"
  }), _vm._v(" caret-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-down"
  }), _vm._v(" caret-square-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-left"
  }), _vm._v(" caret-square-o-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-right"
  }), _vm._v(" caret-square-o-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-square-o-up"
  }), _vm._v(" caret-square-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  }), _vm._v(" caret-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down"
  }), _vm._v(" chevron-circle-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(" chevron-circle-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-right"
  }), _vm._v(" chevron-circle-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-up"
  }), _vm._v(" chevron-circle-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" chevron-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" chevron-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  }), _vm._v(" chevron-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chevron-up"
  }), _vm._v(" chevron-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" exchange")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-down"
  }), _vm._v(" hand-o-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-left"
  }), _vm._v(" hand-o-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-right"
  }), _vm._v(" hand-o-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hand-o-up"
  }), _vm._v(" hand-o-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-down"
  }), _vm._v(" long-arrow-down")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left"
  }), _vm._v(" long-arrow-left")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-right"
  }), _vm._v(" long-arrow-right")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-up"
  }), _vm._v(" long-arrow-up")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-down"
  }), _vm._v(" toggle-down "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-left"
  }), _vm._v(" toggle-left "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-right"
  }), _vm._v(" toggle-right "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-toggle-up"
  }), _vm._v(" toggle-up "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt"
  }), _vm._v(" arrows-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-backward"
  }), _vm._v(" backward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-compress"
  }), _vm._v(" compress")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-eject"
  }), _vm._v(" eject")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-expand"
  }), _vm._v(" expand")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fast-backward"
  }), _vm._v(" fast-backward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fast-forward"
  }), _vm._v(" fast-forward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-forward"
  }), _vm._v(" forward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pause"
  }), _vm._v(" pause")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-play"
  }), _vm._v(" play")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-play-circle"
  }), _vm._v(" play-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-play-circle-o"
  }), _vm._v(" play-circle-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-random"
  }), _vm._v(" random")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-step-backward"
  }), _vm._v(" step-backward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-step-forward"
  }), _vm._v(" step-forward")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stop"
  }), _vm._v(" stop")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play"
  }), _vm._v(" youtube-play")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-500px"
  }), _vm._v(" 500px")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-adn"
  }), _vm._v(" adn")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-amazon"
  }), _vm._v(" amazon")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-android"
  }), _vm._v(" android")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-angellist"
  }), _vm._v(" angellist")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-apple"
  }), _vm._v(" apple")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-behance"
  }), _vm._v(" behance")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-behance-square"
  }), _vm._v(" behance-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket"
  }), _vm._v(" bitbucket")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bitbucket-square"
  }), _vm._v(" bitbucket-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-bitcoin"
  }), _vm._v(" bitcoin "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-black-tie"
  }), _vm._v(" black-tie")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-btc"
  }), _vm._v(" btc")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-buysellads"
  }), _vm._v(" buysellads")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-amex"
  }), _vm._v(" cc-amex")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-diners-club"
  }), _vm._v(" cc-diners-club")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-discover"
  }), _vm._v(" cc-discover")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-jcb"
  }), _vm._v(" cc-jcb")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-mastercard"
  }), _vm._v(" cc-mastercard")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-paypal"
  }), _vm._v(" cc-paypal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-stripe"
  }), _vm._v(" cc-stripe")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-cc-visa"
  }), _vm._v(" cc-visa")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-chrome"
  }), _vm._v(" chrome")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-codepen"
  }), _vm._v(" codepen")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-connectdevelop"
  }), _vm._v(" connectdevelop")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-contao"
  }), _vm._v(" contao")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-css3"
  }), _vm._v(" css3")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dashcube"
  }), _vm._v(" dashcube")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-delicious"
  }), _vm._v(" delicious")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-deviantart"
  }), _vm._v(" deviantart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-digg"
  }), _vm._v(" digg")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dribbble"
  }), _vm._v(" dribbble")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-dropbox"
  }), _vm._v(" dropbox")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-drupal"
  }), _vm._v(" drupal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-empire"
  }), _vm._v(" empire")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-expeditedssl"
  }), _vm._v(" expeditedssl")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  }), _vm._v(" facebook")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-facebook-f"
  }), _vm._v(" facebook-f "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-facebook-official"
  }), _vm._v(" facebook-official")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-facebook-square"
  }), _vm._v(" facebook-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-firefox"
  }), _vm._v(" firefox")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-flickr"
  }), _vm._v(" flickr")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-fonticons"
  }), _vm._v(" fonticons")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-forumbee"
  }), _vm._v(" forumbee")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-foursquare"
  }), _vm._v(" foursquare")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ge"
  }), _vm._v(" ge "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-get-pocket"
  }), _vm._v(" get-pocket")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gg"
  }), _vm._v(" gg")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gg-circle"
  }), _vm._v(" gg-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-git"
  }), _vm._v(" git")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-git-square"
  }), _vm._v(" git-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v(" github")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-github-alt"
  }), _vm._v(" github-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-github-square"
  }), _vm._v(" github-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gittip"
  }), _vm._v(" gittip "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" google")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  }), _vm._v(" google-plus")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-google-plus-square"
  }), _vm._v(" google-plus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-google-wallet"
  }), _vm._v(" google-wallet")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-gratipay"
  }), _vm._v(" gratipay")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hacker-news"
  }), _vm._v(" hacker-news")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-houzz"
  }), _vm._v(" houzz")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-html5"
  }), _vm._v(" html5")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  }), _vm._v(" instagram")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-internet-explorer"
  }), _vm._v(" internet-explorer")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ioxhost"
  }), _vm._v(" ioxhost")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-joomla"
  }), _vm._v(" joomla")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-jsfiddle"
  }), _vm._v(" jsfiddle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-lastfm"
  }), _vm._v(" lastfm")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-lastfm-square"
  }), _vm._v(" lastfm-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-leanpub"
  }), _vm._v(" leanpub")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  }), _vm._v(" linkedin")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square"
  }), _vm._v(" linkedin-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-linux"
  }), _vm._v(" linux")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-maxcdn"
  }), _vm._v(" maxcdn")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-meanpath"
  }), _vm._v(" meanpath")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-medium"
  }), _vm._v(" medium")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki"
  }), _vm._v(" odnoklassniki")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-odnoklassniki-square"
  }), _vm._v(" odnoklassniki-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-opencart"
  }), _vm._v(" opencart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-openid"
  }), _vm._v(" openid")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-opera"
  }), _vm._v(" opera")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-optin-monster"
  }), _vm._v(" optin-monster")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pagelines"
  }), _vm._v(" pagelines")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-paypal"
  }), _vm._v(" paypal")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper"
  }), _vm._v(" pied-piper")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pied-piper-alt"
  }), _vm._v(" pied-piper-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pinterest"
  }), _vm._v(" pinterest")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-p"
  }), _vm._v(" pinterest-p")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-pinterest-square"
  }), _vm._v(" pinterest-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-qq"
  }), _vm._v(" qq")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ra"
  }), _vm._v(" ra "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-rebel"
  }), _vm._v(" rebel")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-reddit"
  }), _vm._v(" reddit")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-reddit-square"
  }), _vm._v(" reddit-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-renren"
  }), _vm._v(" renren")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-safari"
  }), _vm._v(" safari")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-sellsy"
  }), _vm._v(" sellsy")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-alt"
  }), _vm._v(" share-alt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-share-alt-square"
  }), _vm._v(" share-alt-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-shirtsinbulk"
  }), _vm._v(" shirtsinbulk")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-simplybuilt"
  }), _vm._v(" simplybuilt")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-skyatlas"
  }), _vm._v(" skyatlas")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-skype"
  }), _vm._v(" skype")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-slack"
  }), _vm._v(" slack")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-slideshare"
  }), _vm._v(" slideshare")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud"
  }), _vm._v(" soundcloud")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-spotify"
  }), _vm._v(" spotify")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stack-exchange"
  }), _vm._v(" stack-exchange")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stack-overflow"
  }), _vm._v(" stack-overflow")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-steam"
  }), _vm._v(" steam")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-steam-square"
  }), _vm._v(" steam-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon"
  }), _vm._v(" stumbleupon")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stumbleupon-circle"
  }), _vm._v(" stumbleupon-circle")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tencent-weibo"
  }), _vm._v(" tencent-weibo")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-trello"
  }), _vm._v(" trello")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor"
  }), _vm._v(" tripadvisor")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v(" tumblr")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-tumblr-square"
  }), _vm._v(" tumblr-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-twitch"
  }), _vm._v(" twitch")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  }), _vm._v(" twitter")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-twitter-square"
  }), _vm._v(" twitter-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-viacoin"
  }), _vm._v(" viacoin")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-vimeo"
  }), _vm._v(" vimeo")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-vimeo-square"
  }), _vm._v(" vimeo-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-vine"
  }), _vm._v(" vine")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-vk"
  }), _vm._v(" vk")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  }), _vm._v(" wechat "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  }), _vm._v(" weibo")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-weixin"
  }), _vm._v(" weixin")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" whatsapp")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wikipedia-w"
  }), _vm._v(" wikipedia-w")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-windows"
  }), _vm._v(" windows")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wordpress"
  }), _vm._v(" wordpress")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-xing"
  }), _vm._v(" xing")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-xing-square"
  }), _vm._v(" xing-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator"
  }), _vm._v(" y-combinator")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-y-combinator-square"
  }), _vm._v(" y-combinator-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-yahoo"
  }), _vm._v(" yahoo")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-yc"
  }), _vm._v(" yc "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-yc-square"
  }), _vm._v(" yc-square "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-yelp"
  }), _vm._v(" yelp")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  }), _vm._v(" youtube")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-youtube-play"
  }), _vm._v(" youtube-play")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-youtube-square"
  }), _vm._v(" youtube-square")])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('ul', {
    staticClass: "the-icons"
  }, [_c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-ambulance"
  }), _vm._v(" ambulance")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-h-square"
  }), _vm._v(" h-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" heart")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heart-o"
  }), _vm._v(" heart-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v(" heartbeat")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _vm._v(" hospital-o")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-medkit"
  }), _vm._v(" medkit")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v(" stethoscope")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v(" user-md")]), _vm._v(" "), _c('li', {
    staticClass: "fa-hover col-md-3 col-sm-4"
  }, [_c('i', {
    staticClass: "fa fa-wheelchair"
  }), _vm._v(" wheelchair")])]), _vm._v(" "), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0affbb3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/iconselect.vue
// module id = 204
// module chunks = 1